<ol class="inspections">
  <li>
    <span class="inspection-item">{{ integrationDesign?.title }}:</span>
    <ol class="notes">
      <li>
        <strong class="case" style="display: block">פרטי יועץ הבטיחות:</strong>
        <strong>שם: {{ integrationDesign?.safetyConsultant?.name }}</strong>
        <strong
          style="margin-right: 20px"
          *ngIf="integrationDesign?.safetyConsultant?.officeName"
          >שם המשרד:
          {{ integrationDesign?.safetyConsultant?.officeName }}</strong
        >
      </li>
      <li *ngIf="integrationDesign.documents?.isApplicable">
        <span class="case" style="display: block"
          >להלן רשימת המסמכים שהתקבלו:</span
        >
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 25%">
                <strong>שם המסמך</strong>
              </th>
              <th style="width: 15%">
                <strong>קוד זיהוי</strong>
              </th>
              <th style="width: 25%">
                <strong>יוצר</strong>
              </th>
              <th style="width: 15%">
                <strong>תאריך</strong>
              </th>
              <th style="width: 20%">
                <strong>מסקנה</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of integrationDesign.documents?.plans">
              <td>
                <span>{{ doc?.name }}</span>
              </td>
              <td>
                <span>{{ doc?.identificationCode }}</span>
              </td>
              <td>
                <span>{{ doc?.creator }}</span>
              </td>
              <td>
                <span>{{ doc?.date | date : 'shortDate' }}</span>
              </td>
              <td>
                <span>{{ docConclusion(doc?.isPassed) }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </li>
      <li *ngIf="integrationDesign.riskLevel?.isApplicable">
        <strong
          >{{ integrationDesign?.riskLevel?.title }}:

          {{ integrationDesign?.riskLevel?.value }}</strong
        >
      </li>
      <li *ngIf="integrationDesign.structureDescription?.isApplicable">
        <strong
          >{{ integrationDesign?.structureDescription?.title }}:

          {{ integrationDesign?.structureDescription?.value }}</strong
        >
      </li>
      <li *ngIf="integrationDesign.areas?.isApplicable">
        <strong
          >{{ integrationDesign?.areas?.title }}:

          {{ integrationDesign?.areas?.value }}</strong
        >
      </li>
    </ol>
  </li>
  <br />
  <li>
    <span class="inspection-item">{{ integrationCommandPost?.title }}:</span>
    <ol class="notes">
      <li *ngIf="integrationCommandPost.dialRiskLevel?.isApplicable">
        <strong>{{ integrationCommandPost?.dialRiskLevel.title }}:</strong>
        <ol>
          <li *ngIf="integrationCommandPost.dialRiskLevel?.dialNumber">
            <strong style="display: table-cell"
              >מספר טלפון של החייגן:
              {{ integrationCommandPost?.dialRiskLevel.dialNumber }}</strong
            >
          </li>
          <ng-container
            *ngFor="
              let contact of integrationCommandPost?.dialRiskLevel.contacts;
              let i = index
            "
          >
            <li *ngIf="contact.phone || contact.name">
              <strong style="display: table-cell">
                <span
                  >דיווח {{ i + 1 }} - מספר הטלפון אליו מחייג החייגן:
                  {{ contact.phone || '--' }}</span
                >
                <span style="margin-right: 30px"
                  >שם מקבל ההודעה: {{ contact.name || '--' }}</span
                >
              </strong>
            </li>
          </ng-container>
          <li *ngIf="integrationCommandPost.dialRiskLevel?.checkTime">
            <strong style="display: table-cell"
              >שעת בדיקת החייגן:
              {{ integrationCommandPost?.dialRiskLevel.checkTime }}</strong
            >
          </li>
          <li
            *ngFor="
              let note of integrationCommandPost?.dialRiskLevel.getNotes()
                | filterBy : ['addNotesToReport'] : true
            "
          >
            <strong style="display: table-cell">{{ note.notes }}</strong>
          </li>
        </ol>
      </li>
      <li *ngIf="integrationCommandPost.commandPostLocation?.isApplicable">
        <strong
          >{{ integrationCommandPost?.commandPostLocation?.title }}:

          {{ integrationCommandPost?.commandPostLocation?.value }}</strong
        >
      </li>
      <li *ngIf="integrationCommandPost.commandPostParts?.isApplicable">
        <strong>{{ integrationCommandPost?.commandPostParts?.title }}:</strong>
        <ol>
          <li
            *ngFor="
              let note of integrationCommandPost?.commandPostParts?.getNotes()
            "
          >
            <strong style="display: table-cell">{{ note.notes }}</strong>
          </li>
        </ol>
      </li>
      <li *ngIf="integrationCommandPost.installedSystems?.isApplicable">
        <strong>{{ integrationCommandPost?.installedSystems?.title }}:</strong>
        <ol>
          <li
            *ngFor="
              let note of integrationCommandPost?.installedSystems?.getNotes()
                | filterBy : ['addNotesToReport'] : true
            "
          >
            <strong style="display: table-cell">{{ note.notes }}</strong>
          </li>
        </ol>
      </li>
      <li *ngIf="integrationCommandPost.performedActions?.isApplicable">
        <strong>להלן רשימת ההפעלות שבוצעו בהתאם למשטר ההפעלות:</strong>
        <ol>
          <li *ngFor="let activationRegime of activationRegimes">
            <div class="activation-regime">
              <strong
                class="activation-regime-title"
                style="display: table-cell"
                >{{ integrationCommandPost?.performedActions?.title }}:

                {{ activationRegime?.value }}</strong
              >
              <div class="table-container">
                <table #table class="data">
                  <thead>
                    <tr>
                      <th rowspan="2" class="main-cell">
                        <div>
                          <div class="input">
                            <p>INPUT</p>
                            <p>(אירוע)</p>
                          </div>
                          <div class="output">
                            <p>OUTPUT</p>
                            <p>(תגובה)</p>
                          </div>
                        </div>
                      </th>

                      <th
                        [attr.colspan]="
                          activationRegime?.actions?.alerts?.length || 1
                        "
                      >
                        התראות, התרעות ודיווחים
                      </th>
                      <th
                        [attr.colspan]="
                          activationRegime?.actions?.smoke?.length || 1
                        "
                      >
                        שליטה בעשן
                      </th>
                      <th
                        [attr.colspan]="
                          activationRegime.actions?.fireSeperation?.length || 1
                        "
                      >
                        הפרדות אש
                      </th>
                      <th
                        [attr.colspan]="
                          activationRegime?.actions?.systems?.length || 1
                        "
                      >
                        שליטה במערכות
                      </th>
                    </tr>
                    <tr class="sideway">
                      <ng-container
                        *ngFor="
                          let actions of [
                            activationRegime.actions.alerts,
                            activationRegime.actions.smoke,
                            activationRegime.actions.fireSeperation,
                            activationRegime.actions.systems
                          ]
                        "
                      >
                        <th *ngFor="let action of actions">
                          <div>
                            {{ action }}
                          </div>
                        </th>
                        <th class="empty" *ngIf="actions.length === 0">
                          <div></div>
                        </th>
                      </ng-container>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let event of activationRegime.events">
                      <td class="event-col">{{ event.name }}</td>

                      <ng-container
                        *ngFor="
                          let actions of [
                            activationRegime.actions.alerts,
                            activationRegime.actions.smoke,
                            activationRegime.actions.fireSeperation,
                            activationRegime.actions.systems
                          ]
                        "
                      >
                        <td *ngFor="let action of actions">
                          <div
                            class="status-cell"
                            [ngSwitch]="isPassed(event, action)"
                          >
                            <mat-icon *ngSwitchCase="Conclusion.Pass"
                              >check</mat-icon
                            >
                            <mat-icon *ngSwitchCase="Conclusion.Fail"
                              >close</mat-icon
                            >
                            <mat-icon *ngSwitchCase="Conclusion.NotApplicable"
                              >remove</mat-icon
                            >
                            <mat-icon *ngSwitchDefault>remove</mat-icon>
                          </div>
                        </td>
                        <td class="empty" *ngIf="actions.length === 0"></td>
                      </ng-container>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <ol style="margin-right: 40px">
              <li
                *ngFor="
                  let note of activationRegime?.getNotes()
                    | filterBy : ['addNotesToReport'] : true
                "
              >
                <strong style="display: table-cell">{{ note.notes }}</strong>
              </li>
            </ol>

            <br />
          </li>
        </ol>
      </li>
      <li *ngIf="integrationCommandPost.manualActions?.isApplicable">
        <strong>{{ integrationCommandPost?.manualActions?.title }}:</strong>
        <ol>
          <li
            *ngFor="
              let note of integrationCommandPost?.manualActions?.getNotes()
                | filterBy : ['addNotesToReport'] : true
            "
          >
            <strong style="display: table-cell">{{ note.notes }}</strong>
          </li>
        </ol>
      </li>
    </ol>
  </li>
  <br />
  <li>
    <span class="inspection-item" style="font-size: 14pt"
      >כל שינוי במשטר ההפעלות או במערכות שנבדקו, מחייב בדיקה מחדש ע"י מעבדת
      אוטוריטה לאבס.</span
    >
  </li>
  <br />
  <li *ngIf="inspection?.empbededFile?.name">
    <span class="inspection-item"
      >משטר ההפעלות שנבדקו – מצ"ב משטר ההפעלות:</span
    >
    <authority-labs-pdf-viewer
      *ngIf="pdfUrl"
      [pdfUrl]="pdfUrl"
      [pages]="inspection?.empbededFilePages"
      (loaded)="pdfViewerComponentLoaded()"
    >
    </authority-labs-pdf-viewer>
  </li>
  <br />

  <authority-labs-summary-notes
    [summaryNotes]="inspection?.summaryNotes"
  ></authority-labs-summary-notes>
</ol>
